export const MainSystemKeys = {
  udsUibError: 'uds-uib-error',
  connectionIndicator: 'connectionIndicator',
  couplingStatus: 'couplingStatus',
  leadFollowConsist: 'leadFollowConsist',
  lightOn: 'lightOn',
  halfLight: 'halfLight',
  emergencyLight: 'emergencyLight',
  cabActive: 'cabActive',
  wagonIndex: 'wagonIndex',
  udsUibWagonIndex: 'uds-uib-wagon-index'
} as const;
